








































































































import { List, ListItem } from "@goodless/components"
import {Order, OrderType, PaymentMethod, PaymentMethodHelper} from "@goodless/structures";
import { Formatter } from "@goodless/utilities";
import { NavigationMixin } from "@simonbackx/vue-app-navigation";
import { Component, Mixins, Prop } from "vue-property-decorator";

@Component({
    components: {
        List,
        ListItem
    },
})
export default class OrderDetails extends Mixins(NavigationMixin) {
    @Prop({ required: true })
    order: Order

    get isDelivery() {
        return this.order.data.type === OrderType.Delivery
    }

    formatDate(date: Date) {
        return Formatter.capitalizeFirstLetter(Formatter.dateWithDay(date))
    }

    formatTime(date: Date) {
        return Formatter.time(date)
    }

    paymentName(method: PaymentMethod) {
        return PaymentMethodHelper.getName(method)
    }

}
